;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { Row } from 'reactstrap';

/**
 * Organizes an array of ContentSections into bootstrap Rows,
 * so that each row contains 12 columns.
 * We're creating separate rows so that we can change the order of items
 * on a per-row basis.
 */
function ContentRow({ children = [] }) {
  // Return empty if no content sections are provided
  if (!children.length) return null;

  // Keep pushing ContentSections into the current row until a size of 12 is reached.
  // Then start a new row.
  const rows: JSX.Element[][] = [];
  let currentRow: JSX.Element[] = [];
  let currentRowSize = 0;
  children.forEach((contentSection: JSX.Element) => {
    currentRow.push(contentSection);
    currentRowSize += contentSection.props.section.size || 12;
    if (currentRowSize >= 12) {
      rows.push(currentRow);
      currentRow = [];
      currentRowSize = 0;
    }
  });
  // Push the last row into the rows array.
  if (currentRow.length > 0) rows.push(currentRow);

  return (
    <>
      {rows.map((sections, index) => (
        <Row key={`content-row-${index}`}>{sections}</Row>
      ))}
    </>
  );
}

export default ContentRow;
